import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[adsptAccordionHeader]' })
export class AccordionHeaderDirective {
  constructor(readonly tr: TemplateRef<any>) {}
}
